import React from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import styled from "@emotion/styled"
import { css } from "@emotion/react"
import ImageChirurgien from "../components/imageChirurgien"
import { Helmet } from "react-helmet"

const TemoignagesPage = () => (
  <Layout pathEn="/en/testimonials/">
    <SEO
      title="Témoignages de nos patients - Dr Philippe Roure"
      description="Témoignages et avis laissés par les patients du Dr Roure à la suite d'opération de chirurgie orthopédique du membre supérieur (maim, coude. épaule, poignet)."
    />
    <Helmet>
      <link
        rel="alternate"
        hreflang="en"
        href={`https://www.docteurphilipperoure.com/en/testimonials/`}
      />
    </Helmet>
    <ImageChirurgien />
    <WrapperTitle>
      <Breadcrumb>
        <Link to="/">Accueil </Link>
      </Breadcrumb>
      <H1>Témoignages de nos patients</H1>
      <p className="intro">
        Des patientes et patients du Dr Philippe Roure ont eu la gentillesse de
        partager leur expérience et leur prise en charge au travers de
        témoignages : du diagnostic de leur pathologie au suivi post-opératoire.
        Retrouvez ces avis sur les page{" "}
        <a
          href="https://www.google.com/maps/place/Dr+Philippe+Roure/@48.8527158,2.3104715,15z/data=!4m5!3m4!1s0x0:0x635c2eecfa224e06!8m2!3d48.8527158!4d2.3104715"
          target="_blank"
          rel="noreferrer noopener"
        >
          Google Maps
        </a>{" "}
        et{" "}
        <a
          href="https://www.facebook.com/drphilipperoure/"
          target="_blank"
          rel="noreferrer noopener"
        >
          Facebook
        </a>{" "}
        du cabinet.
      </p>
    </WrapperTitle>

    <Wrapper
      css={css`
        .testimonial {
          font-weight: 600;
          font-size: 13px;
          text-align: right;
          margin-top: -6px;
          margin-bottom: 30px;
          margin-right: 100px;

          ::before {
            content: "—";
            margin-right: 6px;
          }
          @media (max-width: 678px) {
            margin-right: 40px;
          }
        }
      `}
    >
      <p>
        «&nbsp;Je souhaite partager mon immense reconnaissance envers le Dr
        Roure qui m’a opérée à deux reprises du{" "}
        <a href="/chirurgie-coude/">coude</a>. Dès la première consultation,
        j’ai été marquée par son écoute, son professionnalisme et sa
        bienveillance. Il prend réellement le temps d’expliquer, de rassurer et
        de répondre à chaque question, ce qui est extrêmement précieux dans des
        moments parfois chargés d’inquiétude.
      </p>
      <p>
        Son savoir-faire, sa précision et son talent inspirent une grande
        confiance. Il excelle dans son travail et porte une attention sincère à
        ses patients. Grâce à lui, j’ai pu aborder les opérations avec beaucoup
        plus de sérénité, et chaque opération a été un succès.
      </p>
      <p>
        Je tiens également à adresser un merci tout particulier à Paula sa
        secrétaire, qui est absolument remarquable. Toujours chaleureuse,
        attentive et disponible, elle accueille avec gentillesse et fait tout
        son possible pour faciliter les démarches et les rendez-vous. Sa
        présence rassurante et son efficacité contribuent énormément à la
        qualité de la prise en charge.&nbsp;»
      </p>
      <p>
        Je me sens sincèrement chanceuse d’avoir été accompagnée par une équipe
        aussi humaine et compétente. Je recommande le Dr Roure les yeux fermés.
      </p>
      <p class="testimonial">Marie K.</p>
      <p>
        «&nbsp;Il y a plus de 6 mois, j'avais besoin d'une reconstruction
        ligamentaire urgente et après quelques recherches, j'ai choisi le Dr
        Roure en raison de sa vaste expérience et des bons avis de ses patients.
        Je ne peux pas être plus satisfait de la décision. À mon avis, il est
        très professionnel et un excellent chirurgien. Il y a plus d'un mois, je
        suis retourné chez le Dr Roure pour une autre opération chirurgicale
        pour l'ablation d'un{" "}
        <a href="/chirurgie-poignet/kyste-synovial-poignet/">kyste</a> à l'autre
        poignet et cette opération s'est également très bien déroulée. &nbsp;»
      </p>
      <p class="testimonial">Corina T. </p>

      <p>
        «&nbsp;Une prise en charge irréprochable, du premier rendez-vous
        jusqu’au suivi post-opératoire&nbsp;! L’opération réalisée par le
        Docteur ROURE a été remarquable&nbsp;: virtuosité, précision, écoute,
        explications claires et un accompagnement rassurant à chaque étape. En
        tant que sportif très investi, opéré d’une{" "}
        <a href="/chirurgie-coude/rupture-biceps/">
          rupture du tendon distal du biceps
        </a>
        , j’ai particulièrement apprécié sa capacité à comprendre mes besoins,
        mes objectifs et mes inquiétudes. Il a su prendre le temps et me
        proposer une prise en charge parfaitement adaptée à ma situation et à ma
        pratique.
      </p>
      <p>
        Un mot particulier pour Paula, son assistante&nbsp;: une réactivité et
        une efficacité assez incroyables, une patience à toute épreuve. Grâce à
        elle, tout est facilité et rassurant. Elle incarne, elle aussi, ce que
        l’on rencontre de plus en plus rarement : la compétence associée à une
        réelle humanité.
      </p>
      <p>
        L’ensemble de l’équipe est au petit soin, avec une attention sincère et
        un professionnalisme qui méritent amplement d’être soulignés.&nbsp;»
      </p>
      <p class="testimonial">Samuel E.</p>

      <p>
        «&nbsp;Grâce au Dr Roure, à J+3 mois j’ai retrouvé un coude tout à fait
        normal, plus de douleurs, et surtout toutes mes capacités: Quel
        soulagement !! Après 2,5 ans de souffrances, de gestion médicale à coups
        d’anti inflammatoires, infiltrations, PRP, Kiné … rien n’améliorait
        mon&nbsp;
        <a href="/chirurgie-coude/epitrochleite-tendinite-mediale/">
          épitrochléite
        </a>{" "}
        (le tendon a fini par déchirer) ni évidemment la compression du nerf
        ulnaire qui s’empirait. J’étais si anxieuse à l’idée de ne plus pouvoir
        exercer correctement mon métier (vétérinaire faisant beaucoup de
        dentisterie et chirurgie), Je ne pouvais plus nager ni même me brosser
        les cheveux à la fin. C’était mon bras droit qui était devenu invalide à
        48 ans! Le Dr Roure m’a si bien opérée que j’ai retrouvé absolument
        toutes mes fonctions, amplitude de mouvement, force et je n’ai plus
        aucune douleur ni fourmillements. Le post-op s’est très bien déroulé, il
        faut bien respecter le temps du repos et de la rééducation, la cicatrice
        est très fine et propre, Dr Roure reste disponible et à l’écoute pendant
        le pré/per/post-op si vous avez la moindre question. Alors un immense
        merci pour la qualité de votre travail et la libération que vous
        apportez à vos patients. &nbsp;»
      </p>
      <p class="testimonial">Laëtitia </p>

      <p>
        «&nbsp;J’ai malheureusement dû me faire opérer de nombreuses fois (mais
        pas pour la même chose je vous rassure) et a chaque fois le Dr Roure a
        fait du super boulot. Il n’opère pas systématiquement, seulement si
        nécessaire. Tout ce travail est possible grâce à sa super équipe qui est
        toujours la même, anesthésiste, soignante mais surtout ses secrétaires
        dont Paula qui est toujours là pour vous accueillir, vous fournir tous
        les papiers nécessaires, est présente à votre réveil pour que tout soit
        le plus simple et le plus clair possible. Elle vous répond même très
        tardivement et vous appelle très tôt quand vous voulez des informations
        urgentes et ce même le weekend suite à l'opération ! Une perle comme
        toute son équipe que j’espère qu’il choie. &nbsp;»
      </p>
      <p class="testimonial">Aurelie L.</p>

      <p>
        «&nbsp;J’ai été opéré sous arthroscopie de l’épaule par le docteur
        Philippe Roure et le résultat est excellent ! J’avais pourtant de graves
        lésions, plusieurs tendons sectionnés, et trois mois seulement après
        l’intervention j’ai retrouvé toutes mes facultés et cela sans aucune
        douleur. Du diagnostic jusqu’au suivi de l’opération, j’ai été
        formidablement pris en charge par le docteur Roure et sa merveilleuse
        assistante Paula qui reste en relation constante avec les patients afin
        de les rassurer et les accompagner au mieux dans cette épreuve. Je
        recommande vivement le docteur Roure que je remercie chaleureusement car
        j’ai pu reprendre une activité physique comme si rien ne m’était arrivé
        et également un grand merci à Paula dont le sourire et l’écoute ont été
        d’un grand soutien. &nbsp;»
      </p>
      <p class="testimonial">Fabrice F.</p>

      <p>
        «&nbsp;Le Docteur Roure m'a opéré avec succès des deux coudes car je
        souffrais d'
        <a href="/chirurgie-coude/epicondylite-tendinite-coude/">
          épicondylite
        </a>
        . Il a été parfait de bout en bout. Faisant preuve d'un grand
        professionnalisme et d'une écoute sans faille, je ne peux que le
        recommander chaudement. Et une mention très spéciale pour sa charmante
        secrétaire Paula dont la gentillesse, l'empathie, la bonne humeur et la
        disponibilité permanente ne fait qu’entériner mon avis : un franc et
        massif 5 étoiles.&nbsp;»
      </p>
      <p class="testimonial">Christophe B.</p>

      <p>
        «&nbsp;Le Dr Roure m'a opéré en avril 2024 de la{" "}
        <a href="/chirurgie-poignet/maladie-de-kienbock/">
          maladie de Kienbock
        </a>
        . Il a fait un très bon travail, un travail impeccable. Je suis très
        heureux. Merci beaucoup !&nbsp;»
      </p>
      <p class="testimonial">Marie A.</p>

      <p>
        «&nbsp;Je pense que la notoriété du docteur Roure dépasse de loin ce que
        l'on peut dire où lire dans ses commentaires.... excellent chirurgien
        j'ai eu à faire à lui pour mon{" "}
        <a href="/chirurgie-nerfs/syndrome-canal-carpien/">canal carpien</a>...
        et ce qui est appréciable c'est qu'il est toujours disponible et qu'il
        se met à votre portée pour vous expliquer ce qui va vous faire et ce qui
        va se passer après de nos jours c'est très appréciable.... j'en profite
        pour ajouter que sa secrétaire, Paula, est charmante est-elle aussi a
        beaucoup d'empathie vis-à-vis des patients du docteur merci à toute
        l'équipe.&nbsp;»
      </p>
      <p class="testimonial">Isabelle R.</p>

      <p>
        «&nbsp;Je tiens à remercier chaleureusement le Docteur Roure et sa
        secrétaire Paula pour leur professionnalisme et leur accompagnement
        exemplaire.
      </p>
      <p>
        J’ai été pris en charge pour une{" "}
        <a href="/chirurgie-epaule/">opération de l’épaule</a>, et tout s’est
        parfaitement déroulé du début à la fin. Le Docteur Roure a su être à
        l’écoute, rassurant et très compréhensif vis-à-vis de mon statut
        étudiant et joueur de haut niveau.
      </p>
      <p>
        Un grand merci également à Paula, qui a été d’une gentillesse
        remarquable, très réactive et d’une efficacité impressionnante. Elle a
        géré mon dossier rapidement et m’a accompagné tout au long de mon
        processus de rééducation avec beaucoup de sérieux et d’attention.
        &nbsp;»
      </p>
      <p class="testimonial">Khaly</p>

      <p>
        «&nbsp;Un grand merci au docteur Roure et à toute son équipe. Suite à
        une chute de vélo, j'ai eu une{" "}
        <a href="/chirurgie-epaule/fracture-clavicule/">
          fracture de la clavicule
        </a>{" "}
        en trois avec un important raccourcissement de l' épaule en septembre
        2023.j'ai été opéré par le docteur Roure fin octobre 2023 (ostéotomie de
        remodelage, synthèse par plaque anatomique). Après une longue
        convalescence et une période de rééducation j'ai récupéré toute la
        fonctionnalité de mon épaule gauche. Je suis très reconnaissant envers
        le Docteur Roure que je recommande. &nbsp;»
      </p>
      <p class="testimonial">Pascal M.</p>

      <p>
        «&nbsp;Dans le cadre de ma profession, j'ai eu affaire plusieurs fois au
        docteur Roure. Je suis très contente d'avoir été adressée à lui : les
        interventions se sont toujours bien passées et j'ai très bien récupéré.
        Mention spéciale pour Paula, sa secrétaire à la Clinique du Sport, qui
        prend toujours le temps, même pendant ses congés, de gérer les dossiers
        et répondre aux questions avec beaucoup de gentillesse.&nbsp;»
      </p>
      <p class="testimonial">Cécile R.</p>

      <p>
        «&nbsp;Un grand merci au Docteur et chirurgien Philippe Roure. Très
        attentif à mes craintes et mes remarques. Deux opérations en un an (
        <Link to="/chirurgie-coude/rupture-biceps/">Biceps</Link> et{" "}
        <Link to="/chirurgie-epaule/rupture-coiffe-des-rotateurs/">
          Coiffe des rotateurs
        </Link>{" "}
        pour le même bras). Opérations totalement réussies. J'ai récupéré
        parfaitement et très rapidement. Un énorme merci à Paula, sa secrétaire,
        toujours agréable souriante, et efficace. Quel que soit le moment, elle
        a toujours parfaitement et rapidement répondu à toutes mes questions,
        administratives bien sûr, mais surtout en faisant le lien entre le Dr
        Roure et moi-même. Une super équipe !!! Merci beaucoup. On peut leur
        faire confiance. &nbsp;»
      </p>
      <p class="testimonial">Daniel</p>

      <p>
        «&nbsp;Grand merci au Docteur Roure et à son assistante Paula ! Le
        chirurgien et Paula, tous les deux très professionnels, d’une grande
        écoute et d’un très bon relationnel, ont répondu à toutes mes questions.
        Le chirurgien m’a expliqué clairement en quoi consiste son intervention
        sans que ce soit trop technique et les suites de l’opération. Paula est
        une assistante très précieuse. Fiable, dévouée et très disponible, elle
        m’a fourni tous les documents administratifs et RDV pour que je puisse
        bien préparer mon admission et la rééducation post-opératoire. Grâce à
        eux deux, je suis allée à mon opération en toute confiance, merci encore
        et n'hésitez pas à visiter la riche documentation du site du docteur
        Roure.&nbsp;»
      </p>
      <p class="testimonial">Denise</p>

      <p>
        «&nbsp;J’ai consulté le Dr Roure suite à une douleur au poignet, j’ai
        déjà était opéré par un autre chirurgien en 2015 de ce poignet mais
        j’avais des douleurs récurrentes (arrêt de travail tous les six mois),
        il m’était impossible d’exercer ma profession correctement. En Juin
        2018, j’ai été de nouveau blessé, mon ancien chirurgien a abandonné, car
        il ne trouvait pas les causes de mes douleurs et tremblements…
      </p>
      <p>
        J’ai donc décidé de consulter le Dr Roure,qui après deux rendez-vous à
        décider de m’opérer, 3 mois après l’opération, j’ai réussi à reprendre
        mon travail en douceur, et aujourd’hui, je peux reprendre mon activité
        normal, aucune douleurs, aucunes gènes, Un GRAND MERCI au Dr ROURE et
        son équipe , superbe prise en charge, tout est expliqué avec clarté, un
        suivi régulier et à l’écoute, une équipe tout simplement génial.
      </p>
      <p>Je conseil fortement le Dr Roure.&nbsp;»</p>
      <p class="testimonial">Kessy</p>

      <p>
        «&nbsp;Chirurgien et homme extraordinaire entouré d'une équipe qui lui
        ressemble, très professionnel et humain. Je recommande vivement le
        Docteur Roure, lui qui a su me réparer me soulager alors que d'autre
        chirurgien en était incapable... Encore merci.&nbsp;»
      </p>

      <p class="testimonial">Aurélie R.</p>

      <p>
        Étant très sportif et après un accident de motocross et une première
        opération de la clavicule avec un autre chirurgien qui ne s'était pas
        bien passé, je devais repartir de zéro. Douleurs et limitation des
        mouvements pendant plus d'1&nbsp;an. Passionné de padel tennis et de
        natation, ce n'était pas évident.
      </p>
      <p>
        Le Dr Roure m'a clairement expliqué ce qu'il était possible de faire.
        Reprise de l'opération, changement de matériel et greffe osseuse au
        menu&nbsp;! J'ai été immédiatement rassuré et convaincu par son côté
        humain et son professionnalisme et j'ai pas hésité à faire 5000km pour
        qu'il me réopère. Belle surprise au réveil car il a réussi à me réopérer
        sans greffe osseuse. Chapeau&nbsp;!
      </p>
      <p>
        Résultat 5&nbsp;mois après reprise du sport comme si de rien n'était
        enfin hors courbature et une très bonne évolution de la consolidation.
        Plus de douleur ni de gène&nbsp;! Pré et Post-opératoire Dr Roure est
        d'une disponibilité et d'une réactivité irréprochable. Merci à
        vous&nbsp;! Mention spécial aussi à Virginie qui a su tout gérer pour
        que les choses se passent de façon très simple malgré la distance.
      </p>

      <p class="testimonial">Sadry D.</p>

      <p>
        «&nbsp;Un grand merci au Dr Roure pour sa parfaite prise en charge.
        Sportivement, &nbsp;»{" "}
        <a href="/temoignage-herve-mazzon.pdf" target="_blank">
          [Lire le témoignage]
        </a>
      </p>

      <p class="testimonial">
        Hervé Mazzon, Équipe de France de Volley (1980-1991)
      </p>

      <p>Merci et bravo au Dr Roure pour cette opération réussie ! </p>
      <p>
        Lors d'une grosse chute en VTT descente dans les Alpes je me suis fait
        une triple fracture de la clavicule droite. J'ai vu un premier
        chirurgien qui m'a dit qu'il n'était pas forcément nécessaire d'opérer
        du fait de mon age (28 ans). J'avais 2,3 cm d'écart entre les deux
        principaux morceau de clavicule mais un fragment mettait du lien entre
        eux, ce qui allait permettre une calcification de la clavicule mais avec
        une importante déformation. (clavicule en Z).
      </p>
      <p>
        J'ai eu la chance ensuite d'avoir un rendez-vous avec le Dr Roure, je
        souhaitais avoir l'avis d'un second chirurgien. Le Dr Roure a été de
        très bon conseil et m'a fortement recommandé de me faire opérer afin de
        pouvoir reprendre le sport comme avant en m’expliquant précisément les
        raisons et comment il souhaitait m'opérer. Je me suis fait opérer par le
        Dr Roure à la clinique du sport à Paris le 10 septembre 2020 et j'ai pu
        reprendre mes activités sportives fin 2020. Je n'ai pas eu de douleur
        après l'opération et la cicatrice est très discrète. Je suis très
        sportif et pratique de nombreux sports (Jiu jitsu brésilien, VTT,
        Running, ...) J'ai réalisé une quinzaine de séances de Kinésithérapie
        chez M. Torti Thomas dans le 17ème.
      </p>
      <p>
        Je recommande vivement le Dr Roure qui est une référence dans son
        domaine et fait preuve de professionnalisme et de sympathie.
      </p>
      <p class="testimonial">Benjamin D.</p>

      <p>
        «&nbsp;Docteur Roure est un chirurgien très professionnel et à l’écoute.
        Toutes les explications avant l’intervention sont données avec détails.
        Toute l’équipe au bloc opératoire est également très compétente. Mes
        interventions (rupture du ligament scapho-lunaire du poignet droit et
        arrachement du ligament du pouce droit) se sont très bien passées et
        sans douleur. Je recommande vivement ce chirurgien très
        excellent.&nbsp;»
      </p>

      <p class="testimonial">Francisco B.</p>

      <p>
        «&nbsp;Malgré un "non, on ne peut rien faire, à part prendre du
        paracétamol en cas de crise" par mon médecin traitant et mon
        rhumatologue, je ne voulais pas subir mon arthrose aux doigts, les
        déformant esthétiquement et handicapant dans le futur... Opérée en
        septembre 2022 d'un{" "}
        <Link to="/chirurgie-poignet/kyste-synovial-poignet/">
          kyste synovial
        </Link>{" "}
        et d'
        <Link to="/chirurgie-main/arthrose-des-doigts/">
          arthrose sur un index
        </Link>{" "}
        (je pense renouveler l'opération sur l'autre index), je remercie
        énormément l'excellent Docteur Roure, qui de par son talent et son
        professionnalisme m'a soulagée. Le résultat est très réussi avec peu de
        cicatrice. Je lui suis très reconnaissante. Un grand merci aussi à
        l'anesthésiste, très efficace, et sans douleur de la piqûre. Enfin,
        Paula, l'assistante dévouée et très sympathique, toujours présente pour
        vous répondre rapidement à toutes questions.&nbsp;»
      </p>

      <p class="testimonial">Isabelle V.</p>

      <p>
        «&nbsp;Un excellent chirurgien, très professionnel à l’écoute du
        patient, qui a soigné le{" "}
        <Link to="/chirurgie-main/maladie-dupuytren/">
          syndrome de Dupuytren
        </Link>{" "}
        parfaitement. Et Paula une secrétaire efficace, professionnelle et très
        souriante.&nbsp;»
      </p>

      <p class="testimonial">Julien S.</p>

      <p>
        «&nbsp;Merci au docteur Philippe Roure. Un chirurgien orthopédique comme
        il en existe peu. Me reconstruire une{" "}
        <Link to="/chirurgie-epaule/fracture-clavicule/">
          clavicule déjà fracturée
        </Link>{" "}
        à 2&nbsp;endroits il y a 30 ans était pour moi une angoisse. Mais
        c'était sans compter les talents du docteur Roure. Toujours à l'écoute,
        rassurant autant que nécessaire et tellement professionnel. Merci
        également à la merveilleuse Paula, assistante hors pair du docteur
        Roure. Toujours avec le sourire, présente pour vous aider, vous
        simplifier tous les tracas administratifs et finalement rendre ce moment
        si délicat qu'est une intervention chirurgicale, presque banale,
        agréable. Et enfin merci à tout le personnel soignant de la clinique du
        sport&nbsp;!! Une vraie équipe !!&nbsp;»
      </p>

      <p class="testimonial">Gilles D.</p>

      <p>
        «&nbsp;La secrétaire du docteur Roure Paula est très sympathique,
        agréable et arrangeante. Il est agréable d'avoir une personne qui vous
        accueille, vous conseille, et qui aime partager avec les autres. Un
        grand merci et une grande reconnaissance au docteur Roure pour son
        professionnalisme et sa disponibilité.&nbsp;»
      </p>

      <p class="testimonial">Agnès F.</p>

      <p>
        «&nbsp;Je tiens à remercier le Dr Roure pour sa gentillesse et à son
        professionnalisme. C’est un super chirurgien qui m’a opéré d'un problème
        d'
        <Link to="/chirurgie-epaule/arthrose-acromio-claviculaire/">
          arthropathie acromio-claviculaire
        </Link>{" "}
        très évolué que je trainais depuis plusieurs années. L'opération s'est
        très bien déroulée, sans surprise, car il m’avait tous expliqué avant
        l’intervention. L'équipe d'infirmières et surtout l'infirmière de nuit
        de la Clinique du sport sont d'une gentillesse et d'une réactivité
        irréprochable. Et pour finir, merci à Paula pour sa compétence et sa
        gentillesse pour la partie administrative. N'hésitez pas à consulter ce
        super chirurgien entouré d'une équipe formidable.&nbsp;»
      </p>

      <p class="testimonial">Abdel B.</p>

      <p>
        «&nbsp;Opéré de mon épaule droite depuis bientôt un an par le docteur
        Roure, tout s'est bien passé et tout s’est déroulé comme il me l'a
        expliqué. Il m'avait prévenu que j'aurais des douleurs pendant un temps
        assez long, je commençais à désespérer et finalement tout est rentré
        dans l'ordre après quelques séances de kiné. Tout va bien, merci
        Docteur.&nbsp;»
      </p>

      <p class="testimonial">Francis R.</p>

      <p>
        «&nbsp;Je viens de me faire opérer de l’épaule droite d’une prothèse
        totale inversée par le DR ROURE. La première approche a été le déclic
        pour accepter la proposition de MR ROURE : c’est un chirurgien proche de
        ses patients. Il nous regarde droit dans les yeux et d’une grande
        simplicité malgré sa renommée nous explique les avantages et les
        inconvénients s’il y en a pour la suite à venir. Je suis allé me faire
        opérer sans inquiétude et tout s’est bien passé. L’opération a eu lieu
        lundi 25 octobre 2021 à la Clinique Montgarde à Aubergenville. Merci Mr
        ROURE pour votre intervention qui va me faire oublier les souffrances
        qui se sont installées pendant tant de mois. Bien sûr tout n’est pas
        terminé. Maintenant, je suis en Centre de Rééducation à AINCOURT mais
        grâce à vous tout va changer. De plus Mr ROURE est avec nous comme il
        est avec ses secrétaires très gentil. Je recommande MR ROURE même s’il
        n’a pas besoin de mon expérience pour être reconnu.&nbsp;»
      </p>

      <p class="testimonial">Chantal G.</p>

      <p>
        «&nbsp;Lors de ma consultation avec le Dr ROURE ce matin pour une
        rupture de la{" "}
        <Link to="/chirurgie-epaule/rupture-coiffe-des-rotateurs/">coiffe</Link>
        , je pensais que mon épaule était perdue et que je ne pourrais plus
        travailler le haut du corps étant sportive. Il m’a totalement rassurée
        et a été très précis et clair dans ses explications, dans le détail. Il
        ne reste plus qu'à passer à l’acte quant à l’opération. J’ai apprécié
        son enthousiasme au regard des résultats, il a égayé ma journée. Je
        tiens à faire une mention spéciale pour son assistante Paula qui est
        d’une extrême gentillesse, à l’écoute, très efficace et compétente. Je
        suis très satisfaite de ma consultation et de l’accueil de Paula.&nbsp;»
      </p>

      <p class="testimonial">Régina T.</p>

      <p>
        «&nbsp;Le docteur Roure est un chirurgien de l'excellence que je
        recommande les yeux fermés. Je l'ai consulté pour une rupture complète
        du ligament scapho lunaire avec arrachement osseux que je traînais
        depuis 6 mois. Auparavant j'avais vu de grands spécialistes qui étaient
        tous sceptiques sur les succès d'une telle opération (aucun ne m'avait
        donné l'envie de passer le pas pour cette intervention chirurgicale
        lourde). Le docteur Roure m'a bien expliqué les aléas de cette blessure,
        mais a su me rassurer. Une fois opéré, il est venu me voir le lendemain
        pour m'encourager à être optimiste et à aller de l'avant. Plus de 5 mois
        et demi après l'intervention je n'ai plus aucune douleur d'avant
        opération, j'ai pu récupérer une bonne mobilité de mon poignet ainsi
        qu'une excellente stabilité et force. Il est à la fois humain et proche
        du patient. Je le remercie pour m'avoir sauvé mon poignet. Je n'oublie
        pas de remercier aussi ses secrétaires disponibles et très
        gentilles.&nbsp;»
      </p>

      <p class="testimonial">Abdel M.</p>

      <p>
        «&nbsp;Le Dr Roure m'a opéré en 2019 pour ôter un kyste synovial
        récalcitrant depuis des années. Le résultat est parfait. La cicatrice
        est pratiquement invisible.&nbsp;»
      </p>

      <p class="testimonial">Thierry L.-A.</p>

      <p>
        «&nbsp;Après une chute, j'ai souffert d'une rupture distale rétractée
        des tendons sus et sous épineux de la{" "}
        <Link to="/chirurgie-epaule/rupture-coiffe-des-rotateurs/">
          coiffe des rotateurs
        </Link>{" "}
        de l'épaule gauche. Après m'être entendu dire successivement par deux
        chirurgiens ayant bonne presse que mon épaule était inopérable, j'ai eu
        la chance de rencontrer une personne qui m'a vivement recommandé le
        Docteur ROURE pour avoir sauvé le coude de son fils après une très grave
        fracture. Lors de la consultation, le docteur ROURE m'a dit
        qu'effectivement mon épaule était très abîmée, mais qu'il pouvait me
        faire récupérer au moins 98% de sa mobilité. J'ai accepté l'intervention
        qui s'est déroulée le 05/03/2020 à la clinique du sport à Paris 5ème et,
        après une quarantaine de séances de rééducation, j'ai récupéré la
        presque totalité des fonctions de mon épaule. Un grand merci et une
        grande reconnaissance au Dr ROURE pour son excellent travail&nbsp;! Je
        remercie également son équipe et sa secrétaire Paula très
        disponible.&nbsp;»
      </p>

      <p class="testimonial">Patrice N.</p>

      <p>
        «&nbsp;Très très sportif, le Docteur Roure m’a opéré de l'épaule gauche
        en 2002. J’ai pu pratiquer mon activité sportive jusqu'à en devenir
        professionnel. En 2020, je me suis blessé de nouveau mais à l'
        <Link to="/chirurgie-epaule/">épaule</Link>&nbsp; droite cette fois-ci.
        Ce sont les yeux fermés que j'ai de nouveau fait appel à ses services.
        Je suis très satisfait de son intervention et je sais par avance que je
        serai de nouveau opérationnel et performant dans quelques semaines. Le
        docteur Roure est un très grand professionnel et qui plus est très
        humain.&nbsp;»
      </p>

      <p class="testimonial">Eric C.</p>

      <p>
        «&nbsp;Dr Roure est un chirurgien en qui j'ai toute confiance. Il m'a
        opéré suite à grave accident où j'ai perdu l'usage de mon bras
        (paralysie du plexus brachial + fracture + rupture des tendons de la
        coiffe). Il dit ce qu'il va faire, il est honnête sur ce qui peut être «
        réparé » ou non, et surtout il fera le max pour vous ! Son assistante
        Paula est au top, super efficace : ordo, prescription, courrier médecin
        correspondant rédigés en sortie de consultation, CR d'opération en 48h.
        Elle est toujours à l'écoute et nous rassure.&nbsp;»
      </p>

      <p class="testimonial">Julie C.</p>

      <p>
        «&nbsp;À mon sens, Dr. Roure est un très grand spécialiste des membres
        supérieurs. Il m’a opéré du coude il y a 8&nbsp;ans avec un résultat
        exceptionnel, et cette année de l’
        <Link to="/chirurgie-epaule/">épaule</Link> (opération également réussie
        et rééducation en cours). J’ai une très grande confiance en lui et ses
        compétences. Et comme il sait bien s’entourer, sa collaboratrice Paula
        est d’une grande disponibilité, attentive, à l’écoute, très
        professionnelle, et d’une grande gentillesse. Merci à eux.&nbsp;»
      </p>

      <p class="testimonial">Renaud S.</p>

      <p>
        «&nbsp;J'ai été opérée par le docteur Roure en juillet 2018 de la main
        et du poignet. Ce docteur est un as des as du bistouri !!! Aucune
        douleur, je cherche encore la cicatrice.... Tout m’a été très bien
        expliqué par le docteur. Si vous avez un soucis, allez le voir les yeux
        fermés.... Son équipe et ses secrétaires sont adorables ainsi que
        l'ensemble du personnel de la clinique de la main à Aubergenville
        (78).&nbsp;»
      </p>

      <p class="testimonial">Martine P.</p>

      <p>
        «&nbsp;Troisième opération avec la même équipe toujours aussi
        professionnelle et sympathique. Le suivi pré et post-op est au top. Le
        Dr Roure est un orfèvre, et les cicatrices résultantes sont à peine
        perceptibles.&nbsp;»
      </p>

      <p>
        Un grand merci au Dr ROURE, à son assistante Paula et à toute son équipe
        pour la qualité de leur travail.&nbsp;»
      </p>

      <p class="testimonial">Laurent P.</p>

      <p>
        «&nbsp;Excellent chirurgien ! Depuis trois ans, je souffrais de
        décharges électriques débilitantes dans le{" "}
        <Link to="/chirurgie-coude/">coude</Link>. Les douleurs partaient des
        deux derniers doigts de la main et remontaient jusque dans la nuque. Un
        véritable calvaire. Parmi la batterie d'examens effectués, l'IRM et
        l'électromyogramme ont permis de déceler une minime compression du nerf
        cubital qui n'a inquiété personne. En effet, le problème de cette
        pathologie est que les résultats sont souvent trompeurs. Ce n'est pas
        parce que le compte rendu n'est pas alarmant que le patient surjoue. Le
        siège des douleurs peut se situer lors de la flexion-extension et non
        lorsque le coude est au repos. Hors, tous les examens que l'on vous
        exigera ne se font jamais en flexion-extension... D'où l'incompréhension
        et la condescendance de certains médecins qui pensent avoir affaire à un
        hypocondriaque. J'ai essayé toutes les thérapies manuelles possibles
        (kiné, ostéo, chiro) et l'infiltration de corticoïdes. En vain. J'ai
        pris rendez-vous avec M. Roure sur la base des avis Google. Son écoute,
        sa bienveillance, sa rigueur, son professionnalisme, je peux vous
        assurer que, lorsque vous souffrez depuis des années, ne sont pas des
        qualités que l'on prend pour acquises. C'est donc avec toute confiance
        que j'ai choisi M. Roure pour l'acte chirurgical de dernier recours.
        L'opération s'est parfaitement déroulée, sans accrocs. Le suivi
        administratif et médical est également à saluer. Un mois après
        l'opération, je ne regrette pas. Les décharges électriques s'estompent
        peu à peu. Les douleurs post-opératoires sont limitées. La cicatrice est
        vraiment discrète. Il reste à effectuer les séances de kiné pour
        récupérer les amplitudes du coude. Allez-y les yeux fermés, mettez-y le
        prix, je vous assure que cela vaut le coup. Votre corps vous
        remerciera.&nbsp;»
      </p>

      <p class="testimonial">Iléana F.</p>

      <p>
        Après un accident de moto, j'ai été pris en charge par le Dr Philippe
        Roure, un excellent chirurgien qui a fait un travail formidable et une
        organisation sans faille. Surtout un très grand merci à son assistante
        Paula pour son professionnalisme hors pair. Une gestion et une
        organisation sans faille du premier RDV jusqu'à la sortie de mon
        hospitalisation. Je recommande sans aucune hésitation ce chirurgien.
      </p>

      <p class="testimonial">Nordine F.</p>

      <p>
        «&nbsp;Excellent{" "}
        <Link to="/chirurgie-main/">chirurgien de la main</Link>. Il m’a opéré
        d’un nerf sectionné au niveau du pouce. J’ai récupéré à 100%, ce qui
        était très important pour moi, car je fais un métier manuel. Confiance
        totale ! Mon fils aussi l’adore ! Il le trouve très drôle et très
        professionnel.&nbsp;»
      </p>

      <p class="testimonial">Dr Gérald F.</p>

      <p>
        «&nbsp;Bientôt une 6ème opération des suites d'un accident de la voie
        publique avec polytraumatisme: -{" "}
        <Link to="/chirurgie-epaule/fracture-clavicule/">
          Fracture de la clavicule
        </Link>{" "}
        avec greffe iliaque + ablation du matériel en totalité après 24 mois de
        consolidation (plaque et 6 broches). - Fracture du cubitus de
        l'avant-bras gauche. -{" "}
        <Link to="/chirurgie-poignet/entorse-poignet/">
          Entorse du poignet droit
        </Link>{" "}
        avec lésion ligamentaire. - Arthroscopie du poignet gauche. -{" "}
        <Link to="/chirurgie-epaule/conflit-sous-acromial/">
          Conflit sous-acromial
        </Link>
        &nbsp; avec tendinopathie du sus-épineux et du long biceps de l'épaule.
        - Résection distale de la clavicule.
      </p>

      <p>
        Le Dr ROURE a fait preuve d'un très grand professionnalisme&nbsp;! Il a
        de l'or au bout des doigts. La méthode qu'il pratique est
        révolutionnaire. Totalement satisfaite par ce chirurgien
        perfectionniste.
      </p>

      <p>
        J'avais beaucoup d’appréhension, j'ai été mise en confiance très vite.
        Ses explications sur les interventions sont claires et détaillées.
        Chirurgien extrêmement à l’écoute de ses patients et disponible pour
        répondre aux inquiétudes liées aux opérations ou aux questions, quelles
        qu'elles soient. Répond de manière précise, contrairement aux mises en
        garde venues de toutes parts en amont des opérations. La prise en charge
        m'a beaucoup aidée. Il a également été patient lors de ma 1ere
        intervention. Sa visite la veille au soir et jusqu'au bloc le jour "J"
        où j’étais dans un grand état de stress et de doutes, je ne l'oublierai
        jamais...aussi pour ses qualités humaines&nbsp;! Le suivi et
        l'accompagnement pré et post opératoire sont au top&nbsp;! Et surtout
        aucune douleur ressentie après les interventions. Cicatrices très peu
        visibles, à ce niveau-là, la chirurgie devient de l'art&nbsp;! Je lui ai
        confié les 5 autres opérations les yeux fermés. Mention spéciale aussi
        pour l’anesthésiste au bloc dont la gentillesse et l'humour m'ont
        déstressée. Secrétaires très réactives et attentionnées. Un grand MERCI
        au Dr ROURE et à son équipe d'une extrême gentillesse et
        disponibilité.&nbsp;»
      </p>

      <p class="testimonial">Catherine F.</p>

      <p>
        «&nbsp;À la suite du visionnage d'un reportage consacré au Dr Roure,
        j'ai décidé de placer ma confiance en lui pour réaliser une opération du
        biceps.&nbsp;»
      </p>

      <p>
        «&nbsp;Force est de constater que j'ai fait le bon choix, car au-delà du
        résultat qui fut à la hauteur de mes attentes légitimes, le cadre
        relationnel dans lequel l'intervention s'est faite fut de qualité
        d'autant que celui-ci s'avère être un grand professionnel de santé tant
        sur le plan technique que sur le plan humain, ce qui devient de plus en
        plus rare de nos jours.&nbsp;»
      </p>

      <p class="testimonial">Stéphan L.</p>

      <p>
        «&nbsp;Un chirurgien en OR, le Docteur Roure m’a opéré il y a 1 an pour
        une{" "}
        <Link to="/chirurgie-coude/rupture-biceps/">
          rupture du tendon du biceps
        </Link>
        . J’étais très mal, car mon biceps ne ressemblait plus à rien (en tant
        que sportif, c’est très dur a accepté). J’ai consulté 3 chirurgiens et
        seul le Dr Roure m’a rassuré et m’a donné une chance de réparer cet
        accident, tout en étant honnête et clair sur les résultats escomptés.
        L’opération a été réalisée avec succès. Le Dr Roure est très
        professionnel et à l’écoute de ses patients. MERCI Docteur pour votre
        travail ! Vous faites des miracles. &nbsp;»
      </p>

      <p class="testimonial">S. Huet</p>

      <p>
        «&nbsp;Opéré le 17 juin de l'épaule, je ne peux que me féliciter du
        travail accompli je loue le professionnalisme et la gentillesse de toute
        l équipe qui a su instaurer une confiance réciproque.&nbsp;»
      </p>

      <p class="testimonial">A. D.</p>

      <p>
        «&nbsp;Dr Roure est un grand chirurgien, il m'a pris en charge après un
        an de souffrance suite à un accident. Il m'a opéré l'
        <Link to="/chirurgie-epaule/">épaule</Link>, la chirurgie m'a soulagé,
        j'ai gagné en mobilité en quelques mois. Mon cas est particulier, je
        suis donc toujours suivi par Dr Roure. Au niveau administratif, son
        assistante Paula est vraiment aux petits soins, elle a préparé ma sortie
        avant même que je quitte la clinique, elle sait qu’on n’est pas en état
        de courir après les documents, elle anticipe et organise tout. Elle est
        très professionnelle et vraiment accueillante.&nbsp;»
      </p>

      <p class="testimonial">Katia B.</p>

      <p>
        «&nbsp;Opérée pour une épaule dans le service du docteur ROURE... un
        magicien... J'avais tous les tendons abîmés ou rompus. L'opération a
        duré 45 min. Je suis restée une nuit et repartie à la maison surprise de
        ne pas avoir plus mal qu'avant l'opération.
      </p>
      <p>
        Le travail de ce chirurgien est fantastique. 6 mois de kiné (50 séances)
        et me voilà totalement remise. Vraiment aucune hésitation à retourner
        voir ce docteur en cas de nouveau problème sur l'autre épaule ou pour
        conseiller un proche ou une connaissance d'aller le consulter.
      </p>
      <p>
        Il paraît expéditif lors des rdv mais son temps est précieux tant il
        connaît son boulot. Il sait ce qu’il fait et le fait comme un magicien :
        vous ne voyez rien et les résultats sont là ! Il donne des explications
        claires et concises, des échéances de progrès qui paraissent
        irréalisables et qui pourtant en plus d'être vraies sont hyper ciblées
        dans le temps.
      </p>
      <p>Allez-y les yeux fermés ! »</p>

      <p class="testimonial">Laurence E.</p>

      <p>
        «&nbsp;Très professionnel, à l'écoute, et de plus très aimable. Un grand
        merci au Docteur Roure et à son assistante.&nbsp;»
      </p>

      <p class="testimonial">Deborah S.</p>

      <p>
        «&nbsp;Ayant consulté pour un troisième avis, le docteur Roure, je suis
        entièrement satisfaite du résultat. En plus de sa qualité
        professionnelle, j’ai également apprécié l’ensemble de son équipe, qui a
        su répondre, à mes besoins, mes questions notamment sa secrétaire Paula
        qui est très disponible et réactive.&nbsp;»
      </p>

      <p class="testimonial">Élie J.</p>

      <p>
        «&nbsp;J'ai été opéré par le chirurgien Philippe Roure pour un problème
        de{" "}
        <Link to="/chirurgie-nerfs/syndrome-canal-carpien/">canal carpien</Link>{" "}
        tout s'est bien passé. Je ne souffre plus du tout. Sans oublier sa
        secrétaire qui est au top Paula&nbsp;: merci aussi pour ton agréable
        travail et ton accueil j'ai apprécié. Je recommande fortement ce
        chirurgien et toute son équipe au niveau de la Clinique du Sport dans le
        5éme arrondissement.&nbsp;»
      </p>

      <p class="testimonial">Christine P.</p>

      <p>
        «&nbsp;Personnel très sympathique et attentionné. Je vous conseille
        particulièrement le docteur Roure pour son professionnalisme et sa
        gentillesse. Je suis venu le voir pour un problème à l’épaule et cela me
        gênait quotidiennement (Décollement du bourrelet glénoïdien et rupture
        du tendon supra-épineux). Depuis l’opération, je n’ai plus aucune gêne.
        MERCI&nbsp;»
      </p>

      <p class="testimonial">Cédric R.</p>

      <p>
        «&nbsp;Excellent chirurgien, grand professionnel et très sympathique. De
        l'avis de mon médecin, il a sauvé mes mains... Digne d'une confiance
        totale, bravo Docteur et merci pour tout !&nbsp;»
      </p>

      <p class="testimonial">Christelle L.</p>

      <p>
        «&nbsp;Très bon chirurgien. Je vous le recommande sincèrement. Opéré en
        2016 de Dupuytren + canal carpien de la main droite. Opéré en 2017 de
        Dupuytren + canal carpien de la main gauche. Clinique d'Aubergenville.
        Équipe très sympathique.&nbsp;»
      </p>
      <p class="testimonial">Will</p>

      <p>
        «&nbsp;Bonjour Dr Roure,
        <br />
        Je voulais juste vous envoyer une petite vidéo pour vous montrer ce que
        j'arrive à faire avec la nouvelle clavicule que vous m'avez fabriqué...
        <br />
        Je tenais à vous remercier car je ne pensais vraiment pas pouvoir
        reprendre mon sport préféré après mon accident (et surtout après la
        réparation douteuse à l'hôpital que vous connaissez…).
        <br />
        Je suis donc confinée en Australie avec ma barre de pole dance et je
        peux m'amuser en toute liberté, sans ressentir ni faiblesse, ni douleur,
        ni contrainte... et tout ça grâce à votre excellent
        travail&nbsp;!!!&nbsp;»
      </p>

      <p class="testimonial">Jessica</p>

      <p>
        «&nbsp;Je me suis fait opérer pour une arthrodèse de la main en 2017 et
        cette fois-ci la même opération sur la main droite. Plus de douleurs aux
        mains et aux poignets. EXCELLENT CHIRURGIEN ! Merci Docteur
        Roure.&nbsp;»
      </p>

      <p class="testimonial">Yvette C.</p>

      <p>
        «&nbsp;Opérer 3 fois et aucun problème, très bon professionnel et très
        gentil qui explique bien les choses.&nbsp;»
      </p>

      <p class="testimonial">Véronique M. </p>

      <p>
        «&nbsp;C’est un excellent médecin et chirurgien qui sait expliquer les
        causes et proposer des solutions quand c’est possible je le recommande
        j’ai un excellent suivi et je n’attends pas très longtemps pour avoir un
        rendez-vous. Il me soigne depuis 15 ans N’hésitez pas à venir vers un
        professionnel compétent.&nbsp;»
      </p>

      <p class="testimonial">Nathalie F. </p>

      <p>
        «&nbsp;Je me suis fait opérer par le Dr Roure d’une épaule instable (
        <Link to="/chirurgie-epaule/operation-latarjet/">
          butée de Latarjet
        </Link>
        ) le 11 mars 2021 à la clinique du sport. C'est un excellent docteur. Il
        m’a tout bien expliqué avant la chirurgie et après l'acte opératoire. Il
        a un excellent suivi du patient. Il est très à l'écoute du patient et il
        a un côté humain extraordinaire. Pour l'acte chirurgical, c'est juste un
        artiste, il a de l'or dans les mains. Mon épaule est vraiment stable, je
        suis heureux de lui avoir fait confiance. Si j'ai le moindre problème,
        j'irai le voir encore sans hésitation. Et pour l'équipe qui l'entoure
        Paula et Virginie, elles sont super géniales et très disponibles. Pour
        le moindre souci, elles sont très réactives. Il me reste plus que la
        rééducation au kiné. Je vous recommande ce professionnel de santé. Un
        gros merci à vous...&nbsp;»
      </p>

      <p class="testimonial"> Omar B.</p>

      <p>
        «&nbsp;Opéré début juillet 2018 de l’épaule droite (biceps
        sous-scapulaire et sus-épineux), je viens témoigner du succès complet et
        sans réserve de l’opération. Ayant 59 ans et étant sportif, la totale
        récupération fonctionnelle est un plaisir évident et quotidien. Thérapie
        manuelle, tennis, sports divers et développé-couché font partie de mes
        pratiques régulières. Indolence totale. Ce n’est en aucun cas un
        témoignage de complaisance, mais une reconnaissance et un remerciement
        pour Philippe Roure. &nbsp;»
      </p>

      <p class="testimonial">Didier V.</p>

      <p>
        «&nbsp;Excellent chirurgien que je recommande vivement de par ses
        compétences et sa gentillesse. La clinique du sport est une bonne
        clinique avec un personnel très aimable, compétent et qui respecte les
        conditions sanitaires. Je tiens à mentionner également le grand
        professionnalisme et les qualités humaines de Paula (son assistante).
        &nbsp;»
      </p>

      <p class="testimonial">Nathalie B.</p>

      <p>
        «&nbsp;Je vous écris pour partager mon témoignage concernant mes 2
        opérations pratiquées par le merveilleux Dr Roure. […] Je vous
        recommande a 100% le Dr Roure c’est un chirurgien à l’écoute de ses
        patients qui ne les laisse jamais tomber et qui trouve toujours la bonne
        solution à vos problèmes. Après 9 longues années de combat me voilà
        enfin tranquille et surtout rétablie... Encore un grand merci au Dr
        Roure pour avoir fait des miracles, car c’était très mal parti et je n’y
        croyais plus... Je n’aurai jamais assez de mots pour le remercier…
        &nbsp;»
      </p>

      <p class="testimonial">Jennifer L.</p>
    </Wrapper>
  </Layout>
)

export default TemoignagesPage

const WrapperTitle = styled.div`
  background-color: white;
  width: 78%;
  margin: 0 auto;
  border-radius: 7px;
  padding: 1.5em 2em 0.9em;
  margin-bottom: 45px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 7px;
  @media (max-width: 1200px) {
    width: 100%;
    margin: 0 12px;
    padding: 1.35em 1.5em 0.7em;
  }
  @media (max-width: 1024px) {
    box-sizing: border-box;
    width: 100%;
    padding: 1.35em 1em 0.7em;
    margin: 0 0 20px;
  }
`
const Breadcrumb = styled.div`
  text-align: center;
  font-size: 0.9em;
  line-height: 1em;
  font-weight: 400;
  a {
    color: #919090;
    text-decoration: none;
  }
  @media (max-width: 678px) {
    font-size: 0.87em;
    margin-bottom: 10px;
  }
`

const H1 = styled.h1`
  font-size: 2.1em;
  @media (max-width: 678px) {
    font-size: 1.9em;
    line-height: 1.1em;
  }
`

const Wrapper = styled.div`
  background-color: white;
  border-radius: 5px;
  margin: 0.5em auto 0.5em;
  padding: 2.25em 2em 1em 2em;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 7px;
  @media (max-width: 1200px) {
    margin: 0 12px 0;
  }
  @media (max-width: 1024px) {
    padding: 1em 1em 0.5em;
    margin: 0;
  }
`
